import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from "@dian-cmp/formulario";

export class DCalc {
    constructor(
        public dutilidades: DOperacionesMatematicasServicio,
    ) {}
    
    // Suma dos números
    public suma(a: string, b: string): string {
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, a, b);
    }

    // Resta el segundo número del primero
    public resta(a: string, b: string): string {
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, a, b);
    }

    // Multiplica dos números
    public mult(a: string, b: string): string {
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, a, b);
    }

    // Divide el primer número por el segundo
    public div(a: string, b: string): string {
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, a, b);
    }
    // Divide el primer número por el segundo
    public div_int(a: string, b: string): string {
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION_ENTERA, a, b);
    }

    // Devuelve el número mayor entre dos números
    public max(a: string, b: string): string {
        let mayor_que = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, a, b);
        return mayor_que?a:b ;
    }

    // Devuelve el número menor entre dos números
    public min(a: string, b: string): string {
        let menor_que = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, a, b);
        return menor_que ? a : b;
    }

    // Verifica si el primer número es mayor que el segundo
    public esMayor(a: string, b: string): boolean {
        let resultado=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, a, b);
        return resultado;
    }
    // Verifica si el primer número es mayor o igual que el segundo
    public esMayorOIgual(a: string, b: string): boolean {
        let resultado=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, a, b);
        return resultado;
    }

    // Verifica si el primer número es menor que el segundo
    public esMenor(a: string, b: string): boolean {
        let resultado=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, a, b);
        return resultado;
    }
    // Verifica si el primer número es menor que el segundo
    public esMenorOIgual(a: string, b: string): boolean {
        let resultado=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, a, b);
        return resultado;
    }
    // Verifica si el primer número es igual a el segundo
    public esIgual(a: string, b: string): boolean {
        let resultado=this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, a, b);
        return resultado;
    }
    // Verifica si el primer número es diferente al segundo
    public esDif(a: string, b: string): boolean {
        let resultado=!this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, a, b);
        return resultado;
    }
}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/utils/dcalc.ts